export default function (tns) {
  const windowWidth =
    document.documentElement.clientWidth || document.body.clientWidth
  const blocks = Array.from(
    document.querySelectorAll(
      '.PageMain--home .FeaturedContent--home .tns-gallery'
    )
  )

  blocks.forEach((block) => {
    let responsive = {
      0: {
        gutter: 0,
        items: 1.2,
      },
    }

    if (windowWidth >= 1024) {
      responsive = {
        0: {
          items: 4,
        },
      }
    } else if (windowWidth >= 768) {
      responsive = {
        0: {
          items: 3,
        },
      }
    } else if (windowWidth >= 640) {
      responsive = {
        0: {
          items: 2,
        },
      }
    }

    applyTinySlideConfigs(block, responsive, tns)
  })
}

function applyTinySlideConfigs(slider, responsive, tns) {
  return tns({
    container: slider,
    gutter: 0,
    nav: false,
    autoHeight: true,
    items: 1.2,
    edgePadding: 0,
    loop: false,
    preventScrollOnTouch: 'force',
    responsive: responsive,
  })
}
